module.exports = __webpack_public_path__ + "img/customer-2.1e865101.png";